import './style.scss';

const Separator = ({ text = 'or' }: { text?: string }) => <div className="separator">{text}</div>;

export default Separator;
